import React, { useEffect, useState } from 'react';
import { createUseStyles } from '../../../../../../../../theming';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import ContactSelect from './ContactSelect';
import Contact from '../../../../../../../../interfaces/api/Contact';

const useStyles = createUseStyles({
  title: {
    width: 400,
    '& h2': {
      color: 'rgba(0, 0, 0, 0.87)',
    },
  },
  error: {
    color: '#f44336',
    fontSize: '.75rem',
    padding: '0 25px',
  },
  formControl: {
    marginBottom: '16px !important',
  },
});

interface Props {
  open: boolean;
  onClose: () => void;
  onValidate: (contact: Contact) => void;
}

const AddContactDialog: React.FC<Props> = ({ open, onClose, onValidate }) => {
  const classes = useStyles();
  const [selectedContact, setSelectedContact] = useState<Contact | null>();
  const [formError, setFormError] = useState<string | undefined>();

  useEffect(() => {
    setFormError(undefined);
  }, []);

  const handleChangeContact = (event, contact?: Contact | null) => {
    setSelectedContact(contact);
  };

  const onSubmit = async () => {
    if (selectedContact) {
      try {
        setFormError(undefined);
        await onValidate(selectedContact);
      } catch (e) {
        setFormError(e.message);
      }
    } else {
      setFormError('Vous devez choisir un contact');
    }
  };

  return (
    <Dialog onClose={onClose} scroll='paper' open={open}>
      <DialogTitle className={classes.title}>Ajouter un contact</DialogTitle>

      <DialogContent>
        <ContactSelect onChange={handleChangeContact} />
      </DialogContent>

      <DialogActions>
        <Button type='button' onClick={onClose} color='primary'>
          Annuler
        </Button>

        <Button type='submit' color='primary' onClick={onSubmit}>
          Ajouter
        </Button>
      </DialogActions>

      {formError && <p className={classes.error}>{formError}</p>}
    </Dialog>
  );
};

export default AddContactDialog;
